import { DeleteOutlined } from '@ant-design/icons';
import { Button, Menu, MenuButton, MenuItem, MenuList, Text, useToast } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useDeleteMasterClassMutation } from '@/@generated/codegen/API';
import { AdminMasterClassListItemType } from '@/pages/admin/components/AdminMasterclassList/columns';
import { useConfirmModal } from '@/ui/ConfirmModal/ConfirmModal';
import { getErrorMessageFromError } from '@/utils/getErrorMessageFromError';

type Props = {
  masterClass: AdminMasterClassListItemType;
};

export function AdminManageMasterClassMenu({ masterClass }: Props) {
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();
  const confirmModalUtils = useConfirmModal();

  const [mutationDeleteMasterClass] = useDeleteMasterClassMutation();

  const handleDeleteMasterClass = useCallback(
    (id: string) => {
      mutationDeleteMasterClass({
        variables: {
          where: {
            id,
          },
        },
      })
        .then(() => {
          toast({
            status: 'success',
            title: t('common.success'),
            description: t('manageMasterClassMenu.delete.successToast'),
          });
        })
        .catch((err: unknown) => {
          toast({
            status: 'error',
            title: t('common.error'),
            description: getErrorMessageFromError(err),
          });
        });
    },
    [mutationDeleteMasterClass, toast, t]
  );
  return (
    <>
      <Menu>
        <MenuButton as={Button} size="xs" variant="secondary" borderRadius={4} aria-label="Options">
          <Text>Manage</Text>
        </MenuButton>
        <MenuList>
          {/* <MenuItem icon={<EditOutlined />} onClick={() => onEditMeeting(meeting)}>
            {t('common.edit')}
          </MenuItem> */}

          <MenuItem
            icon={<DeleteOutlined />}
            onClick={() => {
              confirmModalUtils.confirm({
                title: (
                  <div>
                    {t('manageMasterClassMenu.delete.confirm.title')}
                    <br />
                    {t('common.irreversableAction')}
                  </div>
                ),
                onConfirm: () => {
                  handleDeleteMasterClass(masterClass.id);
                },
              });
            }}
          >
            {t('common.delete')}
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
